import React from "react";
import { Card, Image } from "react-bootstrap";
import logo from "../../assets/img/logos/uniksystem.svg";
import "../../assets/css/icons.css";
import CustomDropdown from "./CustomDropdown";
import { withNamespaces } from "react-i18next";

const image = {
  width: "25rem",
  padding: "15px",
};

const DefaultWidget = ({ apagarWidget, ...props }) => {
  const { t } = props;
  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {t("general.underConstruction")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body style={{ overflowY: "scroll" }}>
          <div className="text-center">
            <Image src={logo} rounded style={image} />
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec augue
            nibh, congue ac semper eget, dictum nec velit. Nam ac sagittis diam,
            ut aliquet ligula.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(DefaultWidget);
